<script setup lang="ts">
import { ref, defineProps } from "vue";

type Props = {
  stepId?: number;
  stepName: string;
  showDetails?: boolean;
  stickyHeight?: string;
  headerImage?: string;
  accordionHeaderColor?: string;
};

defineProps<Props>();

const isOpen = ref(true);
</script>

<template>
  <div class="w-full">
    <div
      class="w-full h-[50px]"
      :class="`${stepId ? 'sticky ' : ''} ${stickyHeight} ${
        accordionHeaderColor ? accordionHeaderColor : 'bg-[#f1f0ee]'
      }`"
    >
      <div
        class="flex items-center justify-between gap-2 p-2 h-[48px] mb-[12px] cursor-pointer rounded-primary-radius hover:bg-[#E5E4E2] duration-500"
        :class="
          isOpen
            ? accordionHeaderColor
              ? 'bg-[#E5E4E2]'
              : 'bg-transparent'
            : 'bg-[#E5E4E2]'
        "
      >
        <h2
          @click="isOpen = !isOpen"
          class="w-full text-[20px] sm:text-[20px] leading-[30px] tracking-[0.01rem] text-primary-text-color font-semibold"
        >
          {{ stepName }}
        </h2>
        <div class="flex gap-6 justify-end w-fit">
          <img
            @click="isOpen = !isOpen"
            class="w-[10px]"
            :class="isOpen ? 'rotate-0' : 'rotate-180'"
            src="@/assets/chevron-up.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div v-if="isOpen">
      <slot />
    </div>
  </div>
  <!-- <div v-else>
    <div class="p-3 bg-white rounded-primary-radius shadow-primary-box-shadow">
      <h3
        class="text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color pb-4 font-semibold"
      >
        {{ props.title }}
      </h3>
      <div class="flex flex-col items-center gap-[18px] my-[30px]">
        <img src="@/assets/text-block-list-image.svg" alt="" />
        <p class="text-sm tracking-[0.01rem] text-[#898790] font-semibold">
          All done!
        </p>
      </div>
    </div>
  </div> -->
</template>
